import { render } from "./LineChart.vue?vue&type=template&id=52198463&ts=true"
import script from "./LineChart.vue?vue&type=script&lang=ts"
export * from "./LineChart.vue?vue&type=script&lang=ts"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSpinnerGrid from 'quasar/src/components/spinner/QSpinnerGrid.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGrid});
